<template>
    <div class="game-option-container">
        <div class="game-option--item" :class="{ 'active': g.isActive }" v-for="(g, index) in games" :key="index"
            @click="handleChooseGame(g)">
            <img :class="`game-option--item__icon icon icon--${g.slug}`" :src="g.icon" />
            <p class="game-option--item__text">{{ g.name }}</p>
        </div>
    </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";

export default {
    mixins: [languageMixins],
    data() {
        return {
            games: [
                {
                    id: 1,
                    name: this.getTranslatedText(`horse`),
                    slug: "hr",
                    isActive: true,
                    icon: require('@/public/img/icon-horse.png')
                },
                {
                    id: 2,
                    name: this.getTranslatedText(`greyhound`),
                    slug: "dg",
                    isActive: false,
                    icon: require('@/public/img/dog-icon.svg')
                }
            ]
        }
    },
    created() {
        this.initActivePage()
    },
    methods: {
        initActivePage() {
            const accountGames = this.$store.state.settings.account_games || [];
            if (accountGames.length === 0) return;

            const queryParams = this.$route.query;
            const iconMap = {
                'hr': require('@/public/img/icon-horse.png'),
                'dg': require('@/public/img/icon-dog.png')
            };

            let filteredGames = accountGames;
            if (queryParams['filter-game']) {
                const filterGames = Array.isArray(queryParams['filter-game'])
                    ? queryParams['filter-game'].map(g => g.trim().toLowerCase())
                    : queryParams['filter-game'].split(',').map(g => g.trim().toLowerCase());
                    
                filteredGames = accountGames.filter(game => 
                    filterGames.includes(game.slug.toLowerCase())
                );
            }

            this.games = filteredGames.map(game => {
                const gameSlug = game.slug.toLowerCase();
                const activeGame = queryParams.game?.toLowerCase() ?? gameSlug;
                
                return {
                    ...game,
                    isActive: gameSlug === activeGame,
                    icon: iconMap[gameSlug] || null
                };
            });
        },
        handleChooseGame(selectedGame) {
            this.games.forEach((game) => {
                game.isActive = game.slug === selectedGame.slug;
            });

            const currentQueryParams = { ...this.$route.query };
            currentQueryParams.game = selectedGame.slug;

            this.$store.dispatch("updateSettingByName", { name: "currentGame", value: selectedGame.slug });
            this.$router.push({ path: "/", query: currentQueryParams });
        }
    }
}
</script>

<style lang="scss">
@import "@/public/scss/components/common/navbar/game-option.scss";
</style>
